import React, { useMemo, useState } from 'react';
import { Header } from './components/Header';
import { FilterBar } from './components/FilterBar';
import { KpiCards } from './components/KpiCards';
import { ThroughputFunnel } from './components/ThroughputFunnel';
import { OfficerTable } from './components/OfficerTable';
import { DrillDownModal, DrillContext } from './components/DrillDownModal';
import { SourceBreakdown } from './components/SourceBreakdown';
import { SourceMix } from './components/SourceMix';
import { applyFilters, DateRangeKey, dateRangeOptions } from './mockData';
export function App() {
  // Filter state
  const [dateRangeKey, setDateRangeKey] = useState<DateRangeKey>('30d');
  const [selectedScope, setSelectedScope] = useState('All Loan Officers');
  const [selectedSources, setSelectedSources] = useState<string[]>([]);
  const [selectedStages, setSelectedStages] = useState<string[]>([]);
  const [includeInactive, setIncludeInactive] = useState(false);
  // View / drill state
  const [activeView, setActiveView] = useState<'overall' | 'bySource' | 'mix'>('overall');
  const [drill, setDrill] = useState<DrillContext | null>(null);
  // Derived filtered data
  const filtered = useMemo(() => applyFilters({
    dateRangeKey,
    scope: selectedScope,
    sources: selectedSources,
    stages: selectedStages,
    includeInactive
  }), [dateRangeKey, selectedScope, selectedSources, selectedStages, includeInactive]);
  const handleKpiClick = (cardId: 'created' | 'converted' | 'funded') => {
    const stage = filtered.funnel.find(s => s.id === cardId);
    if (stage) setDrill({
      type: 'stage',
      stage
    });
  };
  const handleSourceClick = (source: import('./types').SourceBreakdownData) => {
    const totalFunded = filtered.sources.reduce((s, x) => s + x.funded, 0);
    setDrill({
      type: 'source',
      source,
      totalFundedAcrossSources: totalFunded
    });
  };
  const handleClearFilters = () => {
    setDateRangeKey('30d');
    setSelectedScope('All Loan Officers');
    setSelectedSources([]);
    setSelectedStages([]);
    setIncludeInactive(false);
  };
  return <div className="min-h-screen bg-[#f7f5f2] text-gray-900 font-sans flex flex-col" data-id="element-0">
      <Header data-id="element-1" />
      <div className="w-full px-4 py-4 flex-1" data-id="element-2">
        <FilterBar activeView={activeView} onViewChange={setActiveView} dateRangeKey={dateRangeKey} onDateRangeChange={setDateRangeKey} selectedScope={selectedScope} onScopeChange={setSelectedScope} selectedSources={selectedSources} onSourcesChange={setSelectedSources} selectedStages={selectedStages} onStagesChange={setSelectedStages} includeInactive={includeInactive} onIncludeInactiveChange={setIncludeInactive} onClear={handleClearFilters} data-id="element-3" />
        <KpiCards onCardClick={handleKpiClick} created={filtered.kpis.created} converted={filtered.kpis.converted} funded={filtered.kpis.funded} pullThrough={filtered.kpis.pullThrough} avgCycleDays={filtered.kpis.avgCycleDays} data-id="element-4" />

        {activeView === 'overall' && <div className="flex flex-col lg:flex-row gap-4 items-start" data-id="element-5">
            <div className="w-full lg:w-[45%] lg:flex-shrink-0" data-id="element-6">
              <ThroughputFunnel stages={filtered.funnel} onStageClick={stage => setDrill({
            type: 'stage',
            stage
          })} data-id="element-7" />
            </div>
            <div className="w-full lg:flex-1 min-w-0" data-id="element-8">
              <OfficerTable data={filtered.officers} onOfficerClick={officer => setDrill({
            type: 'officer',
            officer
          })} data-id="element-9" />
            </div>
          </div>}
        {activeView === 'bySource' && <SourceBreakdown data={filtered.sources} onSourceClick={handleSourceClick} data-id="element-10" />}
        {activeView === 'mix' && <SourceMix data={filtered.sources} dateRangeLabel={dateRangeOptions.find(o => o.key === dateRangeKey)?.label ?? ''} onSourceClick={handleSourceClick} data-id="element-11" />}
      </div>

      {drill && <DrillDownModal context={drill} onClose={() => setDrill(null)} data-id="element-12" />}
    </div>;
}